// extracted by mini-css-extract-plugin
export default {"button":"QuestionMark_button__krqTe"};